define(function (require) {

    lpTag.VisitorFeedSimulator = {
        createSimulatedAgentSessionOTK: function (req) {
            req.success.call(null, {otk: "1234567890"});
        },

        VisitorFeedSimulatedApi: function (sessionData) {
            var visitorsData;
            var defaultPollingTimeout = 30000000;
            var maxNumberOfVisitors = 50;
            var minNumberOfVisitors = 50;

            var firstTimePollingTimeout = 2000;
            var firstTimeMaxNumberOfVisitors = 10;
            var firstTimeMinNumberOfVisitors = 10;
            var visitorIdConstant = 1000;
            var lastRandomMinutes = 120;
            var firstTimeUse = false;
            var currentlyActive = false;
            var stateSortOrder = ["IN_CHAT", "WAITING_FOR_CHAT", "REP_PUSH_CHAT", "REP_WANTS_TO_CHAT", "CHAT_REFUSED", "AFTER_CHAT", "IN_SITE", "NONE", "NO_CHAT", "LEFT_SITE"];
            var statesWithAgents = ["IN_CHAT", "REP_PUSH_CHAT", "REP_WANTS_TO_CHAT", "AFTER_CHAT", "NO_CHAT", "LEFT_SITE"];
            var organizationsArray = ["", "Texaco", "", "Norsk Hydro asa", "", "Baker & McKenzie LLP", "Synapse Product Development", "", "Kraft Foods", "HVB Group"];
            var agentNamesArray = ["Kenneth Pelowski", "Seth Myers", "Matt McCall", "Michael A. Greeley", "Susan Bryant", "Sara Cohen", "Jeremiah Ryan", "Salar al Khafaji", "Zoltan Szaplonczay", "Paula Keve"];
            var skillsArray = ["French", "Consulting", "Shipping service", "Pre-sales", "Sales, ENT", "Billing, Enterprise", "Sales, English", "Billing", "Accounting", "Finance Service"];
            var osArray = ["Mac OS X Mountain Lion (Mac OS X 10_8)", "Windows XP", "Windows 8", "Linux", "Windows 7", "Windows mobile", "Mac OS 6"];
            var deviceArray = ['DESKTOP', 'TABLET', 'MOBILE'];
            var osToDevice = [0, 0, 1, 0, 0, 2, 0];
            var browserArray = ["Safari 5", "Safari 4", "Firefox", "MSIE 9.0", "MSIE 10.0", "Chrome", "Opera"];
            var pagesArray = [{pageTitle: "Customer Experience Management and Live Chat Software", url: "http://www.liveperson.com"},
                {pageTitle: "Google", url: "http://www.google.com/"},
                {pageTitle: "Facebook", url: "http://www.facebook.com/"},
                {pageTitle: "Welcome to Steam", url: "http://store.steampowered.com/"},
                {pageTitle: "Amazon.com: Online Shopping for Electronics, Apparel, Computers, Books, DVDs & more", url: "http://www.amazon.com/"},
                {pageTitle: "Google Search", url: "https://www.google.co.il/#gs_rn=17&gs_ri=psy-ab&tok=AfCIE0Kkh-a2z-4ad5rzpw&suggest=p&cp=24&gs_id=2n&xhr=t&q=javascript+array+random+sort&es_nrs=true&pf=p&sclient=psy-ab&oq=javascript+array+random+&gs_l=&pbx=1&bav=on.2,or.r_cp.r_qf.&bvm=bv.48293060,d.ZWU&fp=e8eb8c3eed6ad7d0&biw=960&bih=1008"},
                {pageTitle: "Electronics, Cars, Fashion, Collectibles, Coupons and More Online Shopping | eBay", url: "http://www.ebay.com/"},
                {pageTitle: "Wikipedia, the free encyclopedia", url: "https://en.wikipedia.org/wiki/JavaScript"},
                {pageTitle: "Java (programming language) - Wikipedia, the free encyclopedia", url: "https://en.wikipedia.org/wiki/Java_(programming_language)"},
                {pageTitle: "YouTube", url: "http://www.youtube.com/"}];
            var countriesArray = ["Israel", "United States", "France", "Italy", "Spain", "Brazil", "Colombia", "Germany", "United Kingdom", "UZBEKISTAN"];
            var geoStatesArray = [null, "California", null, null, null, null, null, null, "England", null];
            var citiesArray = ["Tel Aviv", "San Diego", "Paris", "Rome", "Barcelona", "Rio de Janeiro", "Cali", "Berlin", "London", "Afrasiab"];
            var countryCodesArray = ["il", "us", "fr", "it", "es", "br", "co", "de", "gb", "uz"];
            var namesArray = ["Adi", "Liron", "Tal", "Itai", "Michal", "Eli", "Very Long Name With family name", "SingleLineAVeryLongNameToTestBreakingTheWords"];
            for (var i = 0; i < 10; i++) { namesArray.push("Visitor " + (i + 1)); }
            var statesArray = ["IN_CHAT", "REP_WANTS_TO_CHAT", "NO_CHAT", "LEFT_SITE"];

            var firstTimeCitiesArray = ["London", "El Paso", "San Diego", "Oslo", "Tokyo", "London", "Tacoma", "Charlotte", "Chicago", "Bremen"];
            var firstTimeCountriesArray = ["United Kingdom", "United States", "United States", "Norway", "Japan", "United Kingdom", "United States", "United States", "United States", "Germany"];
            var firstTimeGeoStatesArray = ["England", "Texas", "California", null, null, "England", "Washington", "North Carolina", "Illinois", null];
            var firstTimeCountryCodesArray = ["gb", "us", "us", "no", "jp", "gb", "us", "us", "us", "de"];
            var firstTimeStatesArray = ["IN_CHAT", "IN_SITE", "IN_SITE", "AFTER_CHAT", "IN_CHAT", "IN_SITE", "WAITING_FOR_CHAT", "IN_CHAT", "WAITING_FOR_CHAT", "IN_CHAT"];
            var firstTimeNamesArray = ["Christopher Tirotta", "Nadine Patel", "Greg Herrera", "Bjorn-Olav Brelin", "Hakon Kvale", "Dave McClure", "Mariam Camargo", "Gadi Maier", "Lida D. Delaney", "Oyvind Nielsen"];
            var ipArray = ["194.134.175.7", "66.228.118.0", "168.150.253.2", "31.45.36.208", "111.107.52.98", "194.134.175.12", "216.186.5.154", "65.190.141.7", "96.127.186.250", "194.121.175.30"];
            var pagesNumbers = [1, 3, 11, 9, 9, 19, 2, 5, 14, 23];
            var osIndex = [0, 1, 5, 4, 2, 6, 1, 0, 1, 1];
            var browserIndex = [0, 5, 5, 3, 4, 5, 5, 5, 2, 1];
            var firstTimePagesArray = [{pageTitle: "Items page", url: "items.asp"},
                {pageTitle: "Product categories", url: "categories.php"},
                {pageTitle: "Search results", url: "search.php"},
                {pageTitle: "FAQ page", url: "faq.asp"},
                {pageTitle: "", url: ""},
                {pageTitle: "", url: "categories.php"},
                {pageTitle: "About us", url: "about_us.php"},
                {pageTitle: "Checkout - step 3", url: "checkout.php"},
                {pageTitle: "Shipping details", url: "shipping.asp"},
                {pageTitle: "Checkout - step 2", url: "checkout.php"}];
            var stateOrderArray = ["IN_SITE", "REP_WANTS_TO_CHAT", "WAITING_FOR_CHAT", "IN_CHAT", "AFTER_CHAT", "LEFT_SITE"];
            var stateTransitionProbabilityArray = [0.25, 0.25, 0.75, 0.1, 0.25, 0.25];
            var statesWithNoDisplay = ["LEFT_SITE"];

            function getTimeFromLastRandomMinutes() {
                return (new Date()).getTime() - Math.floor(lastRandomMinutes * 60000 * Math.random());
            }

            function getPages(numberOfPages, index) {
                var pages = [];
                var currentTime = new Date().getTime();
                var firstPageTime = getTimeFromLastRandomMinutes();
                var timeStep = 60000;
                for (var i = 0; i < numberOfPages; i++) {
                    var page = {};
                    var indexToUse = typeof index !== 'undefined' ? index : Math.floor(pagesArray.length * Math.random());
                    page.pageTitle = pagesArray[indexToUse].pageTitle;
                    page.url = pagesArray[indexToUse].url;
                    page.pageLastAccessTime = firstPageTime + (timeStep * i);
                    if (page.pageLastAccessTime > currentTime) {
                        page.pageLastAccessTime = currentTime;
                    }
                    pages.push(page);
                }
                return pages;
            }

            this.startSession = function () {
                currentlyActive = true;
                if (sessionData.firstTimeUse) {
                    firstTimeUse = true;
                    defaultPollingTimeout = firstTimePollingTimeout;
                    maxNumberOfVisitors = firstTimeMaxNumberOfVisitors;
                    minNumberOfVisitors = firstTimeMinNumberOfVisitors;
                    countriesArray = firstTimeCountriesArray;
                    citiesArray = firstTimeCitiesArray;
                    geoStatesArray = firstTimeGeoStatesArray;
                    countryCodesArray = firstTimeCountryCodesArray;
                    statesArray = firstTimeStatesArray;
                    namesArray = firstTimeNamesArray;
                    pagesArray = firstTimePagesArray;
                }
                if (sessionData.startPolling) {
                    this.startPolling();
                }
            };

            this.endSession = function () {
                currentlyActive = false;
                this.stopPolling();
            };

            this.clearPollingData = function () {
                this.endSession();
            };

            this.isSessionActive = function () {
                return currentlyActive;
            };

            this.startPolling = function () {
                this.polling = true;
                this.getVisitors(this);
                rescheduleTimeout(this);
            };

            function rescheduleTimeout(context) {
                if (context.pollingTimeout) {
                    clearTimeout(context.pollingTimeout);
                    context.pollingTimeout = null;
                }

                if (context.polling) {
                    context.pollingTimeout = setTimeout(function () {
                        context.pollingTimeout = null;
                        context.getVisitors.call(context);
                        rescheduleTimeout(context);
                    }, defaultPollingTimeout);
                }
            }

            this.stopPolling = function () {
                this.polling = false;
                clearInterval(this.pollingTimeout);
                this.pollingTimeout = null;
            };

            function compareVisitorsByStateIndex(a, b) {
                return stateSortOrder.indexOf(a.state.fieldValue) - stateSortOrder.indexOf(b.state.fieldValue);
            }

            this.getVisitors = function () {
                var numberOfVisitors = minNumberOfVisitors + (Math.floor((maxNumberOfVisitors - minNumberOfVisitors) * Math.random()));
                if (firstTimeUse) {
                    visitorsData = getPredefinedVisitors(numberOfVisitors);
                } else {
                    visitorsData = getRandomVisitors(numberOfVisitors);
                }
                visitorsData.sort(compareVisitorsByStateIndex);
                var that = this;
                setTimeout(function () {
                    if (that.onVisitorListFunc) {
                        var visitorsCopy = {visitorsList: {visitors: []}};
                        for (var i = 0; i < visitorsData.length; i++) {
                            if (!firstTimeUse || statesWithNoDisplay.indexOf(visitorsData[i].getState()) < 0) {
                                visitorsCopy.visitorsList.visitors.push(visitorsData[i].getShallowCopy());
                            }
                        }
                        that.onVisitorListFunc(visitorsCopy);
                    }
                }, 0);
            };

            this.onVisitorList = function (onVisitorListFunc) {
                this.onVisitorListFunc = onVisitorListFunc;
            };

            this.startSession();

            function getRandomIndex(array) {
                return Math.floor(array.length * Math.random());
            }

            function getRandomElement(array) {
                return array[getRandomIndex(array)];
            }

            function getRandomVisitors(amount) {
                var visitorsListData = [];

                for (var i = 0; i < amount; i++) {
                    visitorsListData.push(new FakeVisitor(i));
                }

                return visitorsListData;
            }

            function getRandomIp() {
                return Math.floor(255 * Math.random()) + "." + Math.floor(255 * Math.random()) + "." + Math.floor(255 * Math.random()) + "." + Math.floor(255 * Math.random());
            }

            function getRandomNumberOfPages() {
                return Math.floor(10 * Math.random()) - 1;
            }

            function getPredefinedVisitors(amount) {
                var visitorsListData = [];
                if (!visitorsData || visitorsData.length < firstTimeMinNumberOfVisitors || visitorsData.length > firstTimeMaxNumberOfVisitors) {
                    for (var i = 0; i < amount; i++) {
                        visitorsListData.push(new FakeVisitor(i));
                    }
                } else {
                    visitorsListData = visitorsData;
                    updateVisitorStates(visitorsListData);
                }
                return visitorsListData;
            }

            function updateVisitorStates(visitors) {
                if (visitors && visitors.length) {
                    for (var i = 0; i < visitors.length; i++) {
                        var visitor = visitors[i];
                        updateStateForVisitor(visitor);
                    }
                }
                return visitors;
            }

            function updateStateForVisitor(visitor) {
                if (visitor && visitor.getState()) {
                    var stateIndex = stateOrderArray.indexOf(visitor.getState());
                    if (typeof stateIndex !== 'undefined' && stateIndex >= 0 && stateIndex < stateTransitionProbabilityArray.length) {
                        var probability = stateTransitionProbabilityArray[stateIndex];
                        if (Math.random() < probability) {
                            stateIndex = (stateIndex + 1) % stateOrderArray.length;
                            visitor.setState(stateOrderArray[stateIndex]);
                        }
                    }
                }
            }

            function getInnerIndexForVisitor(visitor) {
                return (visitor.id - visitorIdConstant) % firstTimeMinNumberOfVisitors;
            }

            function FakeVisitor(index) {
                var visitorId = visitorIdConstant + index;
                var visitor = {
                    rtSessionId: visitorId,
                    id: visitorId,
                    shark: true
                };

                function checkVisitorStateForAgentName() {
                    if (visitor && visitor.state && visitor.state.fieldValue) {
                        var state = visitor.state.fieldValue;
                        var shouldHaveAgentName = statesWithAgents.indexOf(state) >= 0;
                        if (shouldHaveAgentName) {
                            visitor.agentNickName = visitor.internalAgentName;
                        } else {
                            visitor.agentNickName = "";
                        }
                    }
                }

                visitor.setState = function (state) {
                    visitor.state = {fieldValue: state};
                    checkVisitorStateForAgentName();
                };

                visitor.getState = function () {
                    var state = null;
                    if (visitor.state && visitor.state.fieldValue) {
                        state = visitor.state.fieldValue;
                    }
                    return state;
                };

                visitor.setAgentName = function setAgentName(agentName) {
                    visitor.internalAgentName = agentName;
                    visitor.agentNickName = agentName;
                    checkVisitorStateForAgentName();
                };

                if (firstTimeUse) {
                    setPredefinedParameters();
                } else {
                    setRandomParameters();
                }
                if (!visitor.visitStartTime) {
                    setStartTime(getTimeFromLastRandomMinutes());
                }

                function setPredefinedParameters() {
                    var innerIndex = getInnerIndexForVisitor(visitor);
                    setLocation(innerIndex);
                    setName(namesArray[innerIndex]);
                    visitor.setState(statesArray[innerIndex]);
                    setOS(osIndex[innerIndex]);
                    setBrowser(browserArray[browserIndex[innerIndex]]);
                    setIp(ipArray[innerIndex]);
                    setSkill(skillsArray[innerIndex]);
                    visitor.setAgentName(agentNamesArray[innerIndex]);
                    setOrganization(organizationsArray[innerIndex]);
                    setPages(pagesNumbers[innerIndex], innerIndex);
                }

                function setRandomParameters() {
                    setLocation(getRandomIndex(countriesArray));
                    setName(getRandomElement(namesArray));
                    visitor.setState(getRandomElement(statesArray));
                    setOS(getRandomIndex(osArray));
                    setBrowser(getRandomElement(browserArray));
                    setIp(getRandomIp());
                    setSkill(getRandomElement(skillsArray));
                    visitor.setAgentName(getRandomElement(agentNamesArray));
                    setOrganization(getRandomElement(organizationsArray));
                    setPages(getRandomNumberOfPages());
                }

                function setLocation(countryIndex) {
                    visitor.country = countriesArray[countryIndex];
                    visitor.geoCity = citiesArray[countryIndex];
                    visitor.countryCode = countryCodesArray[countryIndex];
                    if (geoStatesArray[countryIndex]) {
                        visitor.geoState = geoStatesArray[countryIndex];
                    }
                }

                function setName(name) {
                    visitor.identifier = {fieldValue: name};
                }

                function setOS(index) {
                    var os = osArray[index];
                    var device = deviceArray[osToDevice[index]];
                    visitor.os = {fieldValue: os};
                    visitor.deviceFamily = {fieldValue: device};
                }

                function setBrowser(browser) {
                    visitor.browser = {fieldValue: browser};
                }

                function setIp(ip) {
                    visitor.ipAddress = {fieldValue: ip};
                }

                function setSkill(skill) {
                    visitor.skill = {fieldValue: skill};
                }

                function setOrganization(organization) {
                    visitor.geoOrg = organization;
                }

                function setPages(numberOfPages, index) {
                    visitor.pages = getPages(numberOfPages, index);
                    if (visitor.pages && visitor.pages[0] && visitor.pages[0].pageLastAccessTime) {
                        setStartTime(visitor.pages[0].pageLastAccessTime);
                    }
                }

                function setStartTime(time) {
                    visitor.visitStartTime = time;
                }

                visitor.getShallowCopy = function () {
                    // Creating clone without references to inner objects/arrays and without functions
                    return JSON.parse(JSON.stringify(visitor));
                };

                return visitor;
            }
        }
    };

    return lpTag.VisitorFeedSimulator;

});
